var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopuprequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 479,
    viewBox: "0 0 479 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.143 330.72H221.714C221.714 340.267 213.979 348 204.429 348C194.878 348 187.143 340.267 187.143 330.72ZM299.5 348C309.05 348 316.786 340.267 316.786 330.72H282.214C282.214 340.267 289.95 348 299.5 348ZM360 175.2H159.65L151.007 132H118V149.28H136.85L171.422 322.08H325.429V304.8H185.579L180.393 278.88H325.429L360 175.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 0C371.776 0 479 107.224 479 239.5C479 371.776 371.776 479 239.5 479C198.737 479 160.345 468.821 126.743 450.859L0 479L28.1652 352.304C10.2027 318.679 0 280.287 0 239.5C0 107.224 107.224 0 239.5 0ZM239.5 47.9C133.689 47.9 47.9 133.689 47.9 239.5C47.9 271.473 55.7077 302.201 70.413 329.696L78.7955 345.359L63.0843 415.916L133.689 400.252L149.328 408.611C176.823 423.316 207.527 431.1 239.5 431.1C345.311 431.1 431.1 345.311 431.1 239.5C431.1 133.689 345.311 47.9 239.5 47.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopuprequest);
export default __webpack_public_path__ + "static/media/Topup request.de1d56281f3b7ba1ddda24c5472fe655.svg";
export { ForwardRef as ReactComponent };